import { useContext } from "react";
import { FormattedMessage } from "react-intl";
import { PageContainer } from "@packsize/components";
import { Grid, Stack, Typography } from "@mui/material";

import { ProductionContext } from "@/contexts/production";
import { ProductionGroupContext } from "@/contexts/production-group";
import { sortObjectsAscending } from "@/utils/sort";
import { type ProductionGroup } from "@/schemas";

import { ProductionGroupCard } from "./components/production-group-card";

const SelectProductionGroup = () => {
	const { productionGroups, currentMachineGroup } = useContext(ProductionContext);
	const { changeProductionGroup } = useContext(ProductionGroupContext);

	const handleSelectProductionGroup = (productionGroup: ProductionGroup) => {
		if (!currentMachineGroup) {
			return;
		}

		changeProductionGroup(currentMachineGroup, productionGroup);
	};

	return (
		<PageContainer>
			<Stack spacing={2}>
				<Typography variant="h1">
					{currentMachineGroup ? (
						<FormattedMessage
							id="Select production group for machine group {alias}"
							defaultMessage="Select production group for machine group {alias}"
							values={{ alias: currentMachineGroup.alias }}
						/>
					) : null}
				</Typography>

				<Grid container display="grid" gridTemplateColumns="repeat(auto-fill, minmax(280px, 1fr))" gap={2}>
					{sortObjectsAscending(productionGroups, "alias").map((productionGroup) => (
						<ProductionGroupCard
							key={productionGroup.id}
							productionGroup={productionGroup}
							onClick={() => handleSelectProductionGroup(productionGroup)}
						/>
					))}
				</Grid>
			</Stack>
		</PageContainer>
	);
};

export default SelectProductionGroup;
